import React, { useEffect, useRef, useState } from 'react';

// Cloudflare Turnstile widget. Renders nothing unless the server reports
// CAPTCHA as enabled (feature flag ON + keys configured), so forms can mount
// it unconditionally. Calls onToken(token) when solved, onToken(null) on expiry.
let scriptPromise = null;
function loadTurnstileScript() {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

const CaptchaWidget = ({ onToken }) => {
  const containerRef = useRef(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;
  const [siteKey, setSiteKey] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/security/captcha-config')
      .then((r) => r.json())
      .then((cfg) => {
        if (alive && cfg.enabled && cfg.site_key) setSiteKey(cfg.site_key);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!siteKey || !containerRef.current) return undefined;
    let widgetId = null;
    let cancelled = false;
    loadTurnstileScript()
      .then(() => {
        if (cancelled || !containerRef.current || !window.turnstile) return;
        widgetId = window.turnstile.render(containerRef.current, {
          sitekey: siteKey,
          callback: (token) => onTokenRef.current && onTokenRef.current(token),
          'expired-callback': () => onTokenRef.current && onTokenRef.current(null),
          'error-callback': () => onTokenRef.current && onTokenRef.current(null),
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (widgetId !== null && window.turnstile) {
        try { window.turnstile.remove(widgetId); } catch (_) {}
      }
    };
  }, [siteKey]);

  if (!siteKey) return null;
  return <div ref={containerRef} className="captcha-widget" style={{ margin: '12px 0' }} />;
};

export default CaptchaWidget;
